import { http } from '../../../../api/http';
import type { CampoAdicional } from '../types/camposAdicionales';

const ENDPOINT = '/planilla/campo-adicional';

export class CamposAdicionalesService {
  static async getAll(): Promise<CampoAdicional[]> {
    const response = await http.get(ENDPOINT);
    return response.data;
  }

  static async save(campo: CampoAdicional): Promise<CampoAdicional> {
    const response = await http.post(ENDPOINT, campo);
    return response.data;
  }

  static async delete(id: number): Promise<void> {
    await http.delete(`${ENDPOINT}/${id}`);
  }
}
